import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PropTypes from 'prop-types';
import { Label } from '@americanexpress/dls-react';
import { stringconstants } from '../../constants';
import { parseHtml } from '../../utils/util';
/**
 * returns DLS input component
 * @param {*} props
 */
/* eslint complexity: ["error", 30] -- need to increase complexity */
const CreateQr = (props) => {
  const {
    fieldId,
    formSubmissionPayload,
    isPrefilled,
    selectKey,
    prefilledWith,
    fieldLabel,
  } = props;
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (isPrefilled && prefilledWith === stringconstants.filledFormData) {
      setUrl(formSubmissionPayload[selectKey]);
    }
  }, [formSubmissionPayload]);

  return (
    <div className="col-md-12">
      <Label className={fieldLabel.cssProperties.style} htmlFor={fieldId}>
        {parseHtml(fieldLabel.label)}
      </Label>
      <div>
        <QRCodeSVG id={fieldId} value={url} size={130} />
      </div>
    </div>
  );
};

CreateQr.propTypes = {
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  isPrefilled: PropTypes.bool,
  selectKey: PropTypes.string,
  prefilledWith: PropTypes.string,
};

export default CreateQr;
